import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { PackageOpen } from 'lucide-react';

// Fase 2 — al registrar el retorno (paso penúltimo) se designa y NOTIFICA al
// usuario del sistema que entrega el equipo al almacén; su confirmación con
// usuario+contraseña es el último paso.
const RequestReturnConfirmModal = ({ open, onClose, movement, systemUsers = [], onSubmit }) => {
  const [userId, setUserId] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!userId) return;
    setSubmitting(true);
    try {
      await onSubmit(userId);
      setUserId('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) { setUserId(''); onClose(); } }}>
      <DialogContent className="max-w-md" data-testid="request-return-confirm-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <PackageOpen className="h-5 w-5 text-amber-500" />
            Registrar retorno — Entrega al almacén
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Selecciona quién está entregando el equipo al almacén. Se le enviará una notificación
            para que confirme con su usuario y contraseña; esa confirmación es el paso final del retorno.
          </p>
          <div className="rounded-md border-2 border-primary/40 bg-primary/5 p-3">
            <p className="text-sm font-semibold text-primary">Entregué el equipo al inventario.</p>
          </div>
          <div className="space-y-2">
            <Label>Quien entrega al almacén (usuario)</Label>
            <Select value={userId} onValueChange={setUserId}>
              <SelectTrigger data-testid="return-warehouse-user-select">
                <SelectValue placeholder="Selecciona un usuario" />
              </SelectTrigger>
              <SelectContent>
                {systemUsers.map((u) => (
                  <SelectItem key={u.id} value={u.id}>{u.name || u.username}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => { setUserId(''); onClose(); }}>Cancelar</Button>
          <Button
            onClick={handleSubmit}
            disabled={!userId || submitting}
            data-testid="request-return-confirm-submit"
          >
            {submitting ? 'Enviando…' : 'Enviar para confirmación'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RequestReturnConfirmModal;
